<dojo-progress-bar
  [progressPct]="state.currentProgress"
  [showBackButton]="true"
  [backButtonDisabled]="state.isFirstSlide || !canGoBack()"
  (backButtonClick)="slideBack()"
/>
